module.exports = __webpack_public_path__ + "static/media/SparkleIcon.514c4843.svg";